"use strict";
///<reference types="vue-upload-component-evans"/>

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var json_form_data_1 = __importDefault(require("json-form-data"));
/**
 * Creates a XHR request
 *
 * @param {Object} options
 */
var createRequest = function createRequest(options) {
    var xhr = new XMLHttpRequest();
    xhr.open(options.method || 'GET', options.url);
    xhr.responseType = 'json';
    if (options.headers) {
        Object.keys(options.headers).forEach(function (key) {
            xhr.setRequestHeader(key, options.headers[key]);
        });
    }
    return xhr;
};
/**
 * Sends a XHR request with certain body
 *
 * @param {XMLHttpRequest} xhr
 * @param {Object} body
 */
var sendRequest = function sendRequest(xhr, body) {
    return new Promise(function (resolve, reject) {
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                var response;
                try {
                    response = JSON.parse(xhr.response);
                } catch (err) {
                    response = xhr.response;
                }
                resolve(response);
            } else {
                reject(xhr.response);
            }
        };
        xhr.onerror = function () {
            return reject(xhr.response);
        };
        xhr.send(JSON.stringify(body));
    });
};
var ChunkUploadHandler = /** @class */function () {
    /**
     * Constructor
     *
     * @param {File} file
     * @param {Object} options
     */
    function ChunkUploadHandler(file, options) {
        this.file = file;
        this.options = options;
    }
    Object.defineProperty(ChunkUploadHandler.prototype, "maxRetries", {
        /**
         * Gets the max retries from options
         */
        get: function get() {
            return this.options.maxRetries;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "maxActiveChunks", {
        /**
         * Gets the max number of active chunks being uploaded at once from options
         */
        get: function get() {
            return this.options.maxActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "fileType", {
        /**
         * Gets the file type
         */
        get: function get() {
            return this.file.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "fileSize", {
        /**
         * Gets the file size
         */
        get: function get() {
            return this.file.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "fileName", {
        /**
         * Gets the file name
         */
        get: function get() {
            return this.file.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "startAction", {
        /**
         * Gets start action (url)
         */
        get: function get() {
            return this.options.startAction || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "uploadAction", {
        /**
         * Gets upload action (url)
         */
        get: function get() {
            return this.options.uploadAction || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "finishAction", {
        /**
         * Gets finish action (url)
         */
        get: function get() {
            return this.options.finishAction || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "startBody", {
        /**
         * Gets the body to be merged when sending the request in start phase
         */
        get: function get() {
            return this.options.startBody || {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "uploadBody", {
        /**
         * Gets the body to be merged when sending the request in upload phase
         */
        get: function get() {
            return this.options.uploadBody || {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "finishBody", {
        /**
         * Gets the body to be merged when sending the request in finish phase
         */
        get: function get() {
            return this.options.finishBody || {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "headers", {
        /**
         * Gets the headers of the requests from options
         */
        get: function get() {
            return this.options.headers || {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "readyToUpload", {
        /**
         * Whether it's ready to upload files or not
         */
        get: function get() {
            return !!this.chunks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "progress", {
        /**
         * Gets the progress of the chunk upload
         * - Gets all the completed chunks
         * - Gets the progress of all the chunks that are being uploaded
         */
        get: function get() {
            var _this = this;
            var completedProgress = this.chunksUploaded.length / this.chunks.length * 100;
            var uploadingProgress = this.chunksUploading.reduce(function (progress, chunk) {
                return progress + (chunk.progress | 0) / _this.chunks.length;
            }, 0);
            return Math.min(completedProgress + uploadingProgress, 100);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "chunksToUpload", {
        /**
         * Gets all the chunks that are pending to be uploaded
         */
        get: function get() {
            return this.chunks.filter(function (chunk) {
                return !chunk.active && !chunk.uploaded;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "hasChunksToUpload", {
        /**
         * Whether there are chunks to upload or not
         */
        get: function get() {
            return this.chunksToUpload.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "chunksUploading", {
        /**
         * Gets all the chunks that are uploading
         */
        get: function get() {
            return this.chunks.filter(function (chunk) {
                return !!chunk.xhr && !!chunk.active;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkUploadHandler.prototype, "chunksUploaded", {
        /**
         * Gets all the chunks that have finished uploading
         */
        get: function get() {
            return this.chunks.filter(function (chunk) {
                return !!chunk.uploaded;
            });
        },
        enumerable: true,
        configurable: true
    });
    ChunkUploadHandler.prototype.sendFormRequest = function (xhr, data) {
        var body = json_form_data_1.default(data);
        return new Promise(function (resolve, reject) {
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    var response;
                    try {
                        response = JSON.parse(xhr.response);
                    } catch (err) {
                        response = xhr.response;
                    }
                    resolve(response);
                } else {
                    reject(xhr.response);
                }
            };
            xhr.onerror = function () {
                return reject(xhr.response);
            };
            xhr.send(body);
        });
    };
    /**
     * Creates all the chunks in the initial state
     */
    ChunkUploadHandler.prototype.createChunks = function () {
        this.chunks = [];
        var start = 0;
        var end = this.chunkSize;
        while (start < this.fileSize) {
            this.chunks.push({
                blob: this.file.file.slice(start, end),
                startOffset: start,
                active: false,
                retries: this.maxRetries
            });
            start = end;
            end = start + this.chunkSize;
        }
    };
    /**
     * Updates the progress of the file with the handler's progress
     */
    ChunkUploadHandler.prototype.updateFileProgress = function () {
        // @ts-ignore
        this.file.progress = this.progress;
    };
    /**
     * Paues the upload process
     * - Stops all active requests
     * - Sets the file not active
     */
    ChunkUploadHandler.prototype.pause = function () {
        this.file.active = false;
        this.stopChunks();
    };
    /**
     * Stops all the current chunks
     */
    ChunkUploadHandler.prototype.stopChunks = function () {
        this.chunksUploading.forEach(function (chunk) {
            chunk.xhr.abort();
            chunk.active = false;
        });
    };
    /**
     * Resumes the file upload
     * - Sets the file active
     * - Starts the following chunks
     */
    ChunkUploadHandler.prototype.resume = function () {
        this.file.active = true;
        this.startChunking();
    };
    /**
     * Starts the file upload
     *
     * @returns Promise
     * - resolve  The file was uploaded
     * - reject   The file upload failed
     */
    ChunkUploadHandler.prototype.upload = function () {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        this.start();
        return this.promise;
    };
    ChunkUploadHandler.prototype.resolve = function (res) {};
    ChunkUploadHandler.prototype.reject = function (reason) {};
    /**
     * Start phase
     * Sends a request to the backend to initialise the chunks
     */
    ChunkUploadHandler.prototype.start = function () {
        var _this = this;
        sendRequest(createRequest({
            method: 'POST',
            headers: __assign({}, this.headers, {
                'Content-Type': 'application/json'
            }),
            url: this.startAction
        }), __assign({}, this.startBody, {
            phase: 'start',
            mime_type: this.fileType,
            size: this.fileSize,
            name: this.fileName
        })).then(function (res) {
            if (res.status !== 'success') {
                _this.file.response = res;
                return _this.reject('server');
            }
            _this.sessionId = res.data.session_id;
            _this.chunkSize = res.data.end_offset;
            _this.createChunks();
            _this.startChunking();
        }).catch(function (res) {
            _this.file.response = res;
            _this.reject('server');
        });
    };
    /**
     * Starts to upload chunks
     */
    ChunkUploadHandler.prototype.startChunking = function () {
        for (var i = 0; i < this.maxActiveChunks; i++) {
            this.uploadNextChunk();
        }
    };
    /**
     * Uploads the next chunk
     * - Won't do anything if the process is paused
     * - Will start finish phase if there are no more chunks to upload
     */
    ChunkUploadHandler.prototype.uploadNextChunk = function () {
        if (this.file.active) {
            if (this.hasChunksToUpload) {
                return this.uploadChunk(this.chunksToUpload[0]);
            }
            if (this.chunksUploading.length === 0) {
                return this.finish();
            }
        }
    };
    /**
     * Uploads a chunk
     * - Sends the chunk to the backend
     * - Sets the chunk as uploaded if everything went well
     * - Decreases the number of retries if anything went wrong
     * - Fails if there are no more retries
     *
     * @param {Object} chunk
     */
    ChunkUploadHandler.prototype.uploadChunk = function (chunk) {
        var _this = this;
        chunk.progress = 0;
        chunk.active = true;
        this.updateFileProgress();
        chunk.xhr = createRequest({
            method: 'POST',
            headers: this.headers,
            url: this.uploadAction
        });
        chunk.xhr.upload.addEventListener('progress', function (evt) {
            if (evt.lengthComputable) {
                chunk.progress = Math.round(evt.loaded / evt.total * 100);
            }
        }, false);
        this.sendFormRequest(chunk.xhr, __assign({}, this.uploadBody, {
            phase: 'upload',
            session_id: this.sessionId,
            start_offset: chunk.startOffset,
            chunk: chunk.blob
        })).then(function (res) {
            chunk.active = false;
            if (res.status === 'success') {
                chunk.uploaded = true;
            } else {
                if (chunk.retries-- <= 0) {
                    _this.stopChunks();
                    return _this.reject('upload');
                }
            }
            _this.uploadNextChunk();
        }).catch(function () {
            chunk.active = false;
            if (chunk.retries-- <= 0) {
                _this.stopChunks();
                return _this.reject('upload');
            }
            _this.uploadNextChunk();
        });
    };
    /**
     * Finish phase
     * Sends a request to the backend to finish the process
     */
    ChunkUploadHandler.prototype.finish = function () {
        var _this = this;
        this.updateFileProgress();
        var xhr = createRequest({
            method: 'POST',
            headers: this.headers,
            url: this.finishAction
        });
        this.sendFormRequest(xhr, __assign({}, this.finishBody, this.file.data, {
            phase: 'finish',
            session_id: this.sessionId
        })).then(function (res) {
            _this.file.response = res;
            // if (res.status !== 'success') {
            //     return this.reject('server')
            // }
            _this.resolve(res);
        }).catch(function (res) {
            _this.file.response = res;
            _this.reject('server');
        });
    };
    return ChunkUploadHandler;
}();
exports.default = ChunkUploadHandler;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/ChunkUpload/ChunkUploadHandler.ts
// module id = 540
// module chunks = 0